import { render } from "./add-testimonials.vue?vue&type=template&id=ae46bc76"
import script from "./add-testimonials.vue?vue&type=script&lang=js"
export * from "./add-testimonials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__